import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CART_LINK, PRICES } from '../data/content';
export function MobileStickyCTA() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-plum/10 bg-cream/95 px-4 py-3 backdrop-blur lg:hidden" data-id="element-123" data-mp="2snpm14gp7iju">
      <a href={CART_LINK} className="flex w-full items-center justify-between gap-3 rounded-full bg-terracotta px-5 py-3.5 text-cream shadow-lg transition-colors duration-150 ease-out hover:bg-terracotta-dark" data-id="element-124" data-mp="2wqvm1ud7wdhv">
        <span className="font-sans text-sm font-bold uppercase tracking-wide" data-id="element-125" data-mp="36lxdwxyvnto5">Quiero mi guía</span>
        <span className="inline-flex items-center gap-2 font-display text-lg font-black" data-id="element-126" data-mp="3bgth8u9ke3gk">
          <PriceDisplay amount={PRICES.today} data-id="element-127" data-mp="3gd0c9s0f9ujq" />
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="3kfx1i1kgwown" />
        </span>
      </a>
    </div>;
}